import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyAc9NML9wDH4kWELIw_XHz3U2Ym2T5XOV0",
    authDomain: "readinglistapp-c3983.firebaseapp.com",
    projectId: "readinglistapp-c3983",
    storageBucket: "readinglistapp-c3983.appspot.com",
    messagingSenderId: "874397518423",
    appId: "1:874397518423:web:2f83c95d3f3e58b48af112"
  };

  initializeApp(firebaseConfig)

  const db = getFirestore()

  const auth = getAuth()

  export { db, auth }